import ActionButton from '../../../app/shared/components/ActionButton';
import TertiaryButton from '../../../app/shared/components/Button/TertiaryButton';
import Image from '../../../app/shared/components/Image/Image';
import { Panel } from '../../../app/shared/components/Panel/Panel';
import { Authorize } from '../../authentication/Authorize';
import { CartItemDetails } from '../../cart/CartItem/CartItemDetails/CartItemDetails';
import CartItemActions from '../../cart/CartItemActions';
import { OrderDetailsProductTranslation } from '../../localization/SiteTranslation';
import { BuyerPolicy } from '../../Policy';
import css from './OrderItemGroup.css';
import { OrderItemGroupState } from './OrderItemGroupState';

interface OrderItemGroupProps {
  state: OrderItemGroupState;
  translation: OrderDetailsProductTranslation;
}

export const OrderItemGroup = ({ state, translation }: OrderItemGroupProps) => {
  const item = state.item;

  return (
    <Panel
      bodyClassName={css.panelBody}
      header={{
        heading: state.item.name,
        headingActionButtons: state.contextCommands?.any() ? (
          <CartItemActions
            items={state.contextCommands}
            translation={translation.shoppingCartItemPanel.cartItemActions}
          />
        ) : null,
        headerClassName: css.panelHeader,
      }}
    >
      <div className={css.container}>
        <Image
          className={css.image}
          src={state.item.imageUrl}
          width={120}
          height={140}
          sharpeningFactor={1.5}
          scalingMode="fit"
        />
        <div className={css.detailsContainer}>
          <CartItemDetails
            className={css.details}
            code={item.modularCode}
            quantity={item.quantity}
            // Do not show 0 prices
            listPrice={item.listPrice.amount ? item.listPrice : undefined}
            salePrice={item.salePrice.amount ? item.salePrice : undefined}
            translation={translation.shoppingCartItemBasicInfo.cartItemDetails}
          />
        </div>
      </div>
      <Authorize policy={BuyerPolicy}>
        <ActionButton command={state.reorderCommand} buttonElement={TertiaryButton}>
          {translation.reorderButton}
        </ActionButton>
      </Authorize>
    </Panel>
  );
};
